import type { DialogType } from 'client/modules/app/dialogs/types';

/**
 * Dialog types that survive wallet disconnection.
 *
 * All other dialogs are automatically dismissed when the user disconnects
 * (see useAppDialogEffects). Add a type here if the dialog does not require
 * a connected wallet to function.
 */
export const DISCONNECTION_SAFE_DIALOG_TYPES: DialogType[] = [
  'location_restricted',
  'connect',
  'connect_custom_wallet',
  'utm_campaign_connect',
  // Help Center doesn't require a wallet — users should always be able to get help.
  'help_center',
];
